export default __webpack_public_path__ + "static/media/Berlin.b1c8c162.png";